import { SortService } from '_services/sort-service';

export class ProductTypeFilter {
    searchText: string;
    productUseId: number;
    Region: string;
    chps: boolean;
    leedv4: boolean;
    mpi: boolean;
    asthmaAllergy: boolean;
    cradleToCradle: boolean;
    voc: boolean;
    substrateId: number;
    sheenIds: number[];
}

export class ProductType {
    productNumber: string;
    productFamily: string;
    description: string;
    canCutImage: string;
    sheenName: string;
    chps: boolean;
    leedV4: boolean;
    mpi: boolean;
    cradleToCradle: boolean;
    asthmaAllergy: boolean;
    voc: boolean;
}

export class ProductUse {
    id: number;
    application: string;
}

export class Substrate {
    id: number
    abbrev: string
    longName: string
    interior: boolean
    exterior: boolean
}

export class ColorCollection {
    id: number;
    colorCollectionName: string;
    colorStripSize: number;
    rowSize: number;
}

export class ColorType {
    colorUID: string;
    colorNumber: string;
    colorName: string;
    colorCollectionId: number;
    isIncludedInProduct: boolean;
    colorFamilyId: number;
    lrv: number;
    color: RgbColor;
    hasRecommendedPrimer: boolean;

    static noColor() {
        var c = new ColorType();
        var d = new Date();
        var uniqueInt = Math.round(d.getTime() / 100);
        c.colorUID = 'nocolorselected_' + uniqueInt.toString(); // Must be unique
        c.colorNumber = '';
        c.colorName = 'NO COLOR SELECTED';
        c.color = new RgbColor();
        c.color.red = 255;
        c.color.green = 255;
        c.color.blue = 255;
        c.color.hexValue = '#FFFFFF';
        return c;
    }

    static isNoColor(c: ColorType) {
        return c.colorName == "NO COLOR SELECTED";
    }

    // UI
    isHidden: boolean = false;
    isSelected: boolean = false;
}

export class RgbColor {
    red: number;
    green: number;
    blue: number;
    hexValue: string;
}

export class ColorStrip {
    items: ColorType[];

    // UI
    isHidden: boolean = false;
}

export class ColorFamily {
    id: number;
    name: string;

    // UI
    isChecked: boolean = false;
    isEnabled: boolean = true;
}

export class Region {
    name: string;
    type: string;
    abbrev: string;
}

/**
 * A combination of a selected product and color.
 * A pass through the product-selector wizard will result in an array of these.
 */
export class WizardProductColorSelection {
    constructor(
        public productUse: ProductUse,
        public substrate: Substrate,
        public product: ProductType,
        public color: ColorType        
    ) { }

    // Sort properties
    get productFamily(): string {
        return (this.product && this.product.productFamily || null);
    }

    get sheenName(): string {
        return (this.product && this.product.sheenName || null);
    }

    get colorNumber(): string {
        return (this.color && this.color.colorNumber || null);
    }

    get colorName(): string {
        return (this.color && this.color.colorName || null);
    }
}

/**
 * A combination of a selected product, color and room.  
 * The project-schedule will result in an array of these.
 */
export class ScheduleItem extends WizardProductColorSelection {
    constructor(
        productUse: ProductUse,
        substrate: Substrate,
        product: ProductType,
        color: ColorType,        
        public location: string,
        // User defined notes (ex: Trim, walls, etc)
        public notes?: string
    ) {
        super(productUse, substrate, product, color);
    }
}

/**
 * A projection of selected products with assigned locations for use with the project-schedule 'products' tab.
 */
export class ScheduledProductProjection extends WizardProductColorSelection {
    constructor(
        productUse: ProductUse,
        substrate: Substrate,
        product: ProductType,
        color: ColorType,        
        private _locations: string[] = []
    ) {
        super(productUse, substrate, product, color);
    }

    /**
      * A comma separated list of locations that this room is assigned to.
      */
    get locations() {
        return this._locations.join(', ');
    }
}

/**
 * A projection of locations with their scheduled products for use with the project-schedule 'locations' tab.
 */
export class ScheduledLocationProjection {
    constructor(
        public name: string,
        public selections: ScheduleItem[] = []
    ) {
        this.sorter = new SortService('productFamily', 'asc');
    }

    sorter: SortService;

    isOpen: boolean;

    sortTable(propertyName: string) {
        this.sorter.sort(this.selections, propertyName);
    }
}

export class Feedback {
    firstName: string;
    lastName: string;
    company: string;
    phone: string;
    email: string;
    feedback: string;
}

/**
 * DTO to the server side domain class
 */
export class ProjectScheduleItem {
    LocationName: string;
    LocationTag: string;
    ColorUID: string;
    ColorName: string;
    ColorNumber: string;
    Color: RgbColor;
    SheenId: number;
    SheenName: string;
    SheenDisplayOrder: number;
    ProductNumber: string;
    ProductFamily: string;
    ProductName: string;
}
